<script setup>
import {ref, computed} from 'vue'
import {useFormStore} from '@/stores/form'
import FormControlTypeRelationshipManyToMany from '@/common/form-control-type/FormControlTypeRelationshipManyToMany'
import api from '@/services/api'

// Define Component Props
const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object
})

// Dynamic Pinia Store
const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

// Template Child References
const myChild = ref(null)

// Reactive Local State Definitions
const btnDisabled = ref(false)

// Computed Property State Tracking
const tableName = computed(() => formStore.value?.tableName)

const id = computed(() => formStore.value?.id)

const urlSegment = computed(() => {
    return props.field?.name === 'customerEmailMessageId' ? 'customer' : 'internal'
})

// Component Trigger Actions
const sendEmail = async () => {
    if (!confirm('Are you sure?')) return

    btnDisabled.value = true

    try {
        const apiEndpoint = import.meta.env.VITE_API_ENDPOINT || ''
        const url = `${apiEndpoint}/api/order-email/${id.value}/${urlSegment.value}`
        await api.get(url)

        // Defensive execution path tracking to avoid early lifecycle exceptions
        if (myChild.value) {
            myChild.value.loadIds()
        }
    } catch (error) {
        console.error('Failed to send order email:', error)
    } finally {
        btnDisabled.value = false
    }
}
</script>

<template>
    <div>
        <FormControlTypeRelationshipManyToMany ref="myChild" :current-data="currentData" :field="field"
                                               :form-id="formId"/>

        <p v-if="!field.readonly" class="mt-2">
            <button class="btn btn-light" :disabled="btnDisabled" @click="sendEmail">
                Send email
            </button>
        </p>
    </div>
</template>